import React, { ReactNode } from "react";
import { Hyperlink } from "src/components";
import theme, { media } from "src/theme";
import styled from "styled-components";

const StyledHyperlink = styled(Hyperlink)`
  display: inline-block;
  margin-top: 20px;
  padding: ${theme.margins.paddingMedium};
  border: 1px solid ${theme.colors.black};
  color: ${theme.colors.white};
  background-color: ${theme.colors.black};
  font-family: ${theme.fonts.regular};
  text-transform: uppercase;

  ${media.tablet} {
    padding: ${theme.margins.paddingMedium} ${theme.margins.paddingPageBig};
  }
  &:hover {
    background-color: transparent;
    color: ${theme.colors.black};
  }
`;

interface IProps {
  to?: string;
  children?: ReactNode;
}

export const LinkButton = ({ to, children }: IProps): JSX.Element | null => {
  if (!to) {
    return null;
  }

  return (
    <StyledHyperlink className="link-button" to={to}>
      {children}
    </StyledHyperlink>
  );
};
